import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { supabase } from "../lib/supabase";

/**
 * Login
 * Signs users in with Supabase Auth and redirects admins to the admin area.
 */
const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();

    const { data: authData, error: loginError } =
      await supabase.auth.signInWithPassword({
        email,
        password,
      });

    if (loginError || !authData?.user) {
      alert("Login failed: " + (loginError?.message || "Unknown error"));
      return;
    }

    const userId = authData.user.id;

    const { data: adminData } = await supabase
      .from("Admin")
      .select("user_id")
      .eq("user_id", userId)
      .maybeSingle();

    const isAdmin = !!adminData;
    sessionStorage.setItem("userRole", isAdmin ? "admin" : "user");

    navigate(isAdmin ? "/admin/orderManagement" : "/");
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.4 }}
      className="min-h-screen px-4 py-12 bg-[#fff5f5]"
    >
      <form
        onSubmit={handleLogin}
        className="p-8 max-w-md mx-auto shadow-lg bg-white/80 backdrop-blur-md rounded-lg border border-[rgba(92,47,47,0.15)]"
      >
        <h2 className="text-2xl font-bold mb-6 text-[#5c2f2f] text-center drop-shadow-sm">
          Login!
        </h2>

        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full p-3 border border-[#d8bcbc] rounded mb-4 placeholder:text-[#a25d5d] focus:outline-none focus:ring-2 focus:ring-[#5c2f2f]"
          required
        />

        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full p-3 border border-[#d8bcbc] rounded mb-4 placeholder:text-[#a25d5d] focus:outline-none focus:ring-2 focus:ring-[#5c2f2f]"
          required
        />

        <button
          type="submit"
          className="bg-[#5c2f2f] hover:bg-[#3f1f1f] text-white px-4 py-3 rounded w-full font-semibold transition"
        >
          Login
        </button>
      </form>
    </motion.div>
  );
};

export default Login;
